define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/types",
	"csi/xml/ExtractQuery",
	"./_RequestQueryMixin",
	"./ExtractValues",
	"./QueryResults",
	"./Request"
], function(declare, csi, _, types, ExtractQuery, _RequestQueryMixin, ExtractValues, QueryResults, RequestStore) {

	return declare([RequestStore, _RequestQueryMixin], {
		queryClass: ExtractQuery,
		valuesClass: ExtractValues,
		requestBinaryParameter: "XMLFilter",
		requestModule: "SiteAdmin",
		requestOperation: "AggregateExtractStore",

		// {boolean} bReportDb - specify if report DB (Query Accelerator) is enabled and used for this request
		// Example of use - see module slicerCalc
		bReportDB: false,

		// Any[][]: 2-dimensional array of data
		//_data: null,

		// Number: timestamp when data was extracted
		//_dataDate: null,

		// Object: mapping of CNLs to Names
		//_dataNames: null,

		// Object: map of keys to index in _data arrays
		//_indexByKey: null,

		get: function(/*String*/id) {
			// summary: return data row by index
			return this._data[id];
		},

		getDate: function() {
			// summary: return date from response indicating timestamp when data was extracted
			return this._dataDate;
		},

		getKeyIndex: function(/*String*/key) {
			// summary: return index into data for given key
			return this._indexByKey[key];
		},

		getName: function(/*String*/url) {
			// summary: return name for given url
			return this._dataNames[url];
		},

		getValuesStore: function(/*Spec*/spec, /*Object*/storeOptions) {
			// summary: need to extend Extract store's requestParameters (Name) to include Classifier and Metric
			storeOptions.requestParameters = _.extend({
				Classifier: spec.queryKey,
				Metric: ExtractValues.METRIC_COUNT
			}, this.requestParameters);

			return this.inherited(arguments);
		},

		add: function(object, directives) {
			// summary: not supported
			console.assert(false);
		},

		put: function(object, directives) {
			// summary: not supported
			console.assert(false);
		},

		remove: function(id) {
			// summary: not supported
			console.assert(false);
		},

		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: extension point to set store data for given response
			var cube = res.data.CUBE;
			this._data = cube.Data;
			this._dataDate = types.formatTime(parseInt(res.data.JobState.StartTime) * 1000, types.FORMAT_DATETIME);
			this.bReportDB = res.getHeader("PIReportService") == "1";
			this._dataNames = res.data.Names;
			this._indexByKey = csi.hashArray(cube.Columns, null, Number);
		},

		_doQuery: function(query, options) {
			// summary: return data
			var results = QueryResults(this._data);
			results.total = this._data.length;
			return results;
		}
	});
});